module.exports = __webpack_public_path__ + "static/media/loc3_img24.c25b58e4.jpg";